/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateNotizDto } from '../../models/lexplus-create-notiz-dto';
import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface ErlassDetailControllerCreateErlassNotizV1$Params {
  erlassID: number;
      body: LexplusCreateNotizDto
}

export function erlassDetailControllerCreateErlassNotizV1(http: HttpClient, rootUrl: string, params: ErlassDetailControllerCreateErlassNotizV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, erlassDetailControllerCreateErlassNotizV1.PATH, 'post');
  if (params) {
    rb.path('erlassID', params.erlassID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

erlassDetailControllerCreateErlassNotizV1.PATH = '/v1/compliance/erlasse/{erlassID}/notizen';
